import { SxProps, Theme, Typography } from "@mui/material";
import { ComponentChildren, FunctionComponent, Fragment, h } from "preact";

interface ComputedValueProps {
  label: string;
  color?: string;
  tightBottom?: boolean;
  children: ComponentChildren;
}

export const ComputedValue: FunctionComponent<ComputedValueProps> = ({
  label,
  color,
  tightBottom,
  children,
}) => {
  const sx: SxProps<Theme> = { p: 1 };
  if (!tightBottom) {
    sx.mb = 2;
  }
  return (
    <>
      <Typography variant="overline" color={color}>
        {label}
      </Typography>
      <Typography variant="h5" sx={sx} color={color}>
        {children}
      </Typography>
    </>
  );
};
